export const navbarMenu = [
  {
    id: 1,
    label: "Beranda",
    pathname: "/efunding",
  },
  {
    id: 2,
    label: "Tentang Kami",
    pathname: "/tentang-kami",
  },
  {
    id: 3,
    label: "Produk Mitra Kami",
    pathname: "/list-produk-deposito",
  },
  // {
  //   id: 4,
  //   label: "Layanan Kami",
  //   pathname: "/layanan-kami",
  // },
  {
    id: 5,
    label: "Hubungi Kami",
    pathname: "/hubungi-kami",
  },
];



// WEBPACK FOOTER //
// ./src/utils/navbar_menu.js